import React ,{useEffect, useState}from 'react';
import ImageBackground from '../../assets/images/Rectangle 42405.png';
import BoxOne from '../../assets/images/boxOne.webp';
import BoxTwo from '../../assets/images/boxTwo.webp';
import { useTranslation } from "react-i18next";
import useLanguageDirection from '../../hooks/useLanguageDirection';
import CopyLinkWithoutBackground from '../iFrame/copyLinkWithoutBackground';


const CustomIntroSection = ({ title }) => {
  const {  i18n } = useTranslation();

  const direction = useLanguageDirection();
  
useEffect(() => {
  const savedLanguage = localStorage.getItem("language");
  i18n.changeLanguage(savedLanguage);
  // document.documentElement.dir = savedLanguage === "en" ? "rtl" : "ltr";
}, [i18n]);

  return (
    <div className="relative w-full md:h-[275px] h-[175px] " dir={direction}>
      {/* Background Image */}
      <img
        src={ImageBackground}
        alt="Your Image Description"
        className="object-cover w-full h-full"
      />
      {/* Centered Content */}
      <div className=" flex flex-col absolute inset-0  items-center justify-center">
        <div className="flex items-center">
          {/* BoxOne */}
          <img
            src={direction === "rtl" ? BoxOne : BoxTwo}
            alt="box"
            className={` md:h-20 h-[72px]  relative top-[-10px] ${
              direction === "rtl"
                ? "right-[10px] md:right-[20px]"
                : "left-[10px] md:left-[20px]"
            }`}
          />
          {/* Title Section */}
          <div className="inline-block p-2 text-center md:px-8 bg-custom-yellow min-w-[210px] md:min-w-[400px]">
            <h2 className="text-lg font-bold text-black md:text-3xl">
              {title}
            </h2>
          </div>
          {/* BoxTwo */}
          <img
            src={direction === "ltr" ? BoxOne : BoxTwo}
            alt="box"
            className={` md:h-20 h-[72px] relative top-[-10px] ${
              direction === "ltr"
                ? "right-[10px] md:right-[20px]"
                : "left-[10px] md:left-[20px]"
            }`}
          />
        </div>
        {/* <div
          className="relative w-1/2 md:h-[275px] h-[50px] "
          dir={direction}
        >
          <CopyLinkWithoutBackground />
        </div> */}
      </div>
    </div>
  );
};

export default CustomIntroSection;
